// removed by extract-text-webpack-plugin
module.exports = {"widget":"_3tPkbxtLGt1f1BHArYcx0-","content":"X9NGR95vJukKfdXmZg1KV","title":"_1wjrcIwE0QXLG0rTZUS9jH","boxRow":"_3tTAAI6i3YC7z_f-CDf70t","nextBoxRow":"_1m3H35NzURODt6Tnl3fp53","boxInfo":"rLilEbM5SMhquwND-Eh7p","invoiceId":"_1pYBMwRKxsXMB6cvpN3M-6","boxCount":"_1sRuZKIYtyWrQIoOAB6DsT","comingUp":"_2OGdma3MfGRgQyLk4jsW_b"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/BoxStatusList/widget.scss
// module id = 1268
// module chunks = 0